import type { Dictionary } from './en'

export const sv = {
  nav: { features: 'Funktioner', pricing: 'Pris', faq: 'Frågor', account: 'Mitt konto', signIn: 'Logga in' },
  hero: {
    title: 'Alt-Tab för din Mac',
    tagline: 'macOS växlar appar. AppSwitch låter ⌥Tab växla fönster — alla fönster, även de tre dokumenten i samma app.',
    download: 'Hämta för Mac', seePricing: 'Se priset',
    note: 'Gratis · macOS 15 eller senare · Apple silicon och Intel',
    hint: 'Håll ⌥ och tryck Tab — släpp för att växla',
  },
  features: {
    heading: 'För dig som har tjugo fönster öppna',
    sub: 'Ett tryck på ⌥Tab visar dem alla. Du släpper och är framme.',
    items: [
      { title: 'Varje fönster, inte varje app', body: 'Växlaren i macOS byter mellan appar. AppSwitch byter mellan fönster — även de tre dokumenten i samma app.' },
      { title: 'Tangentbordet först', body: '⌥Tab framåt, ⌥⇧Tab bakåt, piltangenter genom rutnätet. Släpp ⌥ så kommer det valda fönstret fram.' },
      { title: 'Stjäl aldrig fokus', body: 'Din app förblir aktiv tills du faktiskt väljer. AppSwitch bor i menyraden, utan symbol i Dock som står i vägen.' },
      { title: 'Direktvisning', body: 'Se det verkliga innehållet i varje fönster i stället för en generisk appsymbol. Minimerade fönster syns direkt i växlaren.' },
    ],
  },
  pricing: {
    heading: 'Köp en gång. Den är din.',
    sub: 'Själva växlaren är gratis och komplett — ingen testversion, inget bortskalat. Pro lägger till de två funktioner som kräver licens.',
    free: 'Gratis', pro: 'Pro', ribbon: 'Engångsköp',
    freePrice: '0 €', once: 'en gång',
    freeSub: 'Allt du behöver för att sluta använda ⌘Tab.',
    proSub: 'Ingen prenumeration. Ingenting förnyas, någonsin.',
    freeList: ['Komplett fönsterväxlare på ⌥Tab', 'Styrning med tangentbord och mus', 'Rutnät och lista', 'Menyradsapp, ingen Dock-symbol'],
    proList: ['Allt i gratisversionen', 'Direktvisning av varje fönster', 'Minimerade fönster i växlaren', 'Två Mac-datorer per licens'],
    download: 'Hämta', buy: 'Skaffa AppSwitch Pro', buyBusy: 'Öppnar kassan…',
    freeFoot: 'Inget konto. Inget kort. Inget slutdatum.',
  },
  faq: {
    heading: 'Frågor',
    items: [
      { q: 'Varför behöver AppSwitch Hjälpmedel?', a: 'Det är enda sättet macOS låter en app fånga ⌥Tab före alla andra, lista dina fönster och ta fram ett. Utan det fungerar appen inte alls. Du ger tillgången själv i Systeminställningar och kan dra tillbaka den när som helst.' },
      { q: 'Är det en prenumeration?', a: 'Nej. AppSwitch Pro är ett engångsköp. Ingenting förnyas, ingenting dras igen, och uppdateringar inom nuvarande huvudversion ingår.' },
      { q: 'På hur många Mac-datorer får jag använda den?', a: 'Två per licens. Du kan frigöra en plats när som helst från ditt konto eller i appen, så att byta dator blir aldrig ett supportärende.' },
      { q: 'Skickas mina fönstertitlar någonstans?', a: 'Nej. Inget fönsterinnehåll, ingen fönstertitel och ingen tangenttryckning lämnar din Mac. Enda nätverksanropet är licenskontrollen, och bara om du köpt Pro. Gratisversionen rör aldrig nätverket.' },
      { q: 'Vilka macOS-versioner stöds?', a: 'macOS 15 eller senare, på Apple silicon och Intel.' },
    ],
  },
  listMode: {
    heading: 'Två sätt att se dina fönster',
    sub: 'Du växlar från menyraden, eller med tangenten , medan växlaren är öppen.',
    grid: { title: 'Rutnät, med förhandsvisningar', body: 'Miniatyrer av det verkliga innehållet. Bäst när du känner igen ett fönster på vad som står i det.' },
    list: { title: 'Lista, med fullständiga titlar', body: 'En tät kolumn där hela titeln på varje fönster får plats. Bäst för tjugo terminaler, eller filer vars namn skiljer sig först på slutet.' },
  },

  footer: { terms: 'Användarvillkor', privacy: 'Integritetspolicy' },
  consent: {
    text: 'Vi använder Google Analytics för att förstå vilka sidor som är användbara. Ingenting mäts utan ditt samtycke. Se vår',
    privacyLink: 'integritetspolicy', accept: 'Acceptera', decline: 'Neka',
  },
} satisfies Dictionary
